import React from "react";
import { ChemClear } from "../modules/ChemClear";

export function ChemClearPage(props) {
  return <ChemClear {...props} />;
}
